module.exports = __webpack_public_path__ + "img/1554020681.39c44915.jpg";